import { initializeApp } from "firebase/app";
import {
  deleteToken,
  getMessaging,
  getToken,
  onMessage,
} from "firebase/messaging";
import { FCM_CONFIG } from "./sw-const";

// Your web app's Firebase configuration
export const firebaseConfig = FCM_CONFIG;

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const FCM_TOKEN_KEY = "fcm_token_v1";

export { messaging, getToken, onMessage, deleteToken, FCM_TOKEN_KEY };
